import { DRAW_MODES } from '@pixi/constants';

class BatchDrawCall {
  constructor() {
    this.texArray = null;
    this.blend = 0;
    this.type = DRAW_MODES.TRIANGLES;
    this.start = 0;
    this.size = 0;
    this.data = null;
  }
}

export { BatchDrawCall };
//# sourceMappingURL=BatchDrawCall.mjs.map
